export default __webpack_public_path__ + "2057dfcd5d0d42c9ead6532c3e656a6e.png";